module.exports = __webpack_public_path__ + "static/media/Follower_Button-10.8d5d7610.png";